import React from 'react'
import clsx from 'clsx'
import { ls } from '../../../locale'

import Icon from "react-icons-kit/Icon";
import { userCircleO } from "react-icons-kit/fa/userCircleO";
import { PriceBox } from './PriceBox';

import iconStyles from '../../../styles/icon.module.scss'


export default function PriorityCheckin({passengers, ancillaries, currencyCode, onSelectService, onClearService}) {

  if(!Array.isArray(passengers)) return null;
  if(!Array.isArray(ancillaries)) return null;
  if(!ancillaries.some(a => Array.isArray(a.passengers) && a.passengers.some(p => Array.isArray(p.priorityCheckin) && p.priorityCheckin.length > 0))) return null;

  const rExtraPage = ls.t('ExtraPage');

  return (
    <div className='tw-mt-4 tw-mb-10'>
      <h1>{rExtraPage.PriorityCheckin.Title}</h1>
      <div className='md:tw-shadow-outline-gray tw-mt-5 tw-bg-white'>
        <Description />
        <div className='tw-flex tw-flex-col tw-gap-6 md:tw-gap-0'>
          {passengers.map((passenger, index) => {
            return (
              <PassengerBox key={index} 
                passenger={passenger} 
                ancillaries={ancillaries} 
                currencyCode={currencyCode} 
                onSelectService={onSelectService}
                onClearService={onClearService} 
              />)
          })}
        </div>
      </div>
    </div>
  )
}

function Description() {

  const rExtraPage = ls.t('ExtraPage');

  let terms = rExtraPage.PriorityCheckin.Terms;
  if(typeof terms === 'string') terms = terms.split(/[\r\n]/);

  let specs = rExtraPage.PriorityCheckin.Specs;
  if(typeof specs === 'string') specs = specs.split(/[\r\n]/);

  return (
    <div className={clsx('tw-border tw-border-solid tw-border-gray-200 tw-p-4'
      ,'tw-flex tw-flex-col tw-gap-3 md:tw-flex-row md:tw-justify-between'
      ,'tw-shadow-outline-gray tw-mb-6 md:tw-shadow-none md:tw-mb-0'
    )}>
      <div>
        <div className='tw-font-bold'>{rExtraPage.PriorityCheckin.Desc}</div>
        { terms.map((term, index) => <div key={index}>{term}</div>) }
      </div>
      <div className='tw-flex tw-flex-row tw-justify-start tw-items-center tw-gap-2'>
        <img src='/images/priority.png' alt='priority' className='tw-h-28' />
        <div>
          { specs.map((spec, index) => <div key={index}>{spec}</div>) }
        </div>
      </div>
    </div>
  )
}


function PassengerBox({passenger, ancillaries, currencyCode, onSelectService, onClearService}) {

  const services = findPassengerServices(passenger.id, ancillaries);
  if(!services.length) return null;

  const handleServiceClick = (service, select) => {
    if(select) {
      if(typeof onClearService === 'function') {
        onClearService({
          passengerId: passenger.id,
          logicalFlightId: service.logicalFlightId,
          ssrCode: service.ssrCode,
        });
      }
      return
    }

    if(typeof onSelectService === 'function') {
      onSelectService({
        passengerId: passenger.id,
        logicalFlightId: service.logicalFlightId,
        ssrCode: service.ssrCode,
      });
    }
  }

  const paxName = passenger.firstName && passenger.lastName 
                  ? `${passenger.firstName} ${passenger.lastName}` 
                  : `${passenger.paxTypeName} Passenger ${passenger.paxIndex}`;

  return (
    <div className={clsx('tw-flex tw-flex-col md:tw-flex-row md:tw-items-center md:tw-justify-between',
      'tw-border tw-border-solid tw-border-gray-200',
      'tw-shadow-outline-gray md:tw-shadow-none'
    )}>
      <div className='tw-p-6 md:tw-px-4 tw-flex tw-flex-row tw-items-center'>
        <Icon icon={userCircleO} className={iconStyles.user} />{paxName}
      </div>
      <div className='tw-flex tw-flex-col md:tw-flex-row md:tw-justify-end'>
        {services.map((service, index) => {
          const selected = Array.isArray(passenger.priorityCheckin) && passenger.priorityCheckin.some(x => x.logicalFlightId === service.logicalFlightId);
          return (<PriceBox key={index} 
            service={service} 
            selected={selected} 
            included={service.included} 
            currencyCode={currencyCode}  
            onClick={() => handleServiceClick(service, selected)}
          />)
        })}
      </div>
    </div>
  )
}

function findPassengerServices(passengerId, ancillaries) {
  const result = [];
  if(!Array.isArray(ancillaries)) return result;

  ancillaries.forEach(anci => {
    if(!Array.isArray(anci.passengers)) return;
    const passenger = anci.passengers.find(p => p.passengerId === passengerId);
    if(!Array.isArray(passenger?.priorityCheckin)) return;

    result.push(...passenger.priorityCheckin);
  })

  return result;
}